/* Match product and article titles; preserve partial-word and SKU searches. */
(() => {
  const scope = (text) => {
    text = text.replace(/^title:([^\s]+)$/, '$1');
    const words = text.trim().split(/\s+/).filter(Boolean);
    if (!words.length || /\b(?:title|variants\.sku):/.test(text)) return text;
    const escape = (word) => word.replace(/[\\"():*]/g, '');
    if (words.length === 1 && /\d/.test(words[0]) && /^[\w-]{6,}$/.test(words[0])) {
      return `variants.sku:${escape(words[0])}*`;
    }
    if (words.length === 1) return escape(words[0]);
    // Shopify's last-word prefix expansion does not work reliably with a
    // repeated field qualifier. Anchor the first word in the product name,
    // then let Shopify expand the remaining partial search terms normally.
    return words.map((word, index) => `${index === 0 ? 'title:' : ''}${escape(word)}`).join(' ');
  };
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !/\/search\/?$/.test(new URL(form.action).pathname)) return;
    const field = form.querySelector('[name="q"]');
    if (!field || !field.value.trim()) return;
    event.preventDefault();
    const params = new URLSearchParams(new FormData(form));
    params.set('q', scope(field.value));
    params.set('type', 'product,article');
    params.set('options[prefix]', 'last');
    window.location.assign(`${form.action}?${params}`);
  });
  // Also correct saved links to the old, unrestricted search page.
  const url = new URL(window.location.href);
  if (/\/search\/?$/.test(url.pathname) && url.searchParams.get('q')) {
    const original = url.searchParams.get('q');
    const scoped = scope(original);
    if (scoped !== original || url.searchParams.get('type') !== 'product,article') {
      url.searchParams.set('q', scoped);
      url.searchParams.set('type', 'product,article');
      url.searchParams.set('options[prefix]', 'last');
      window.location.replace(url.href);
    }
  }
})();
